import { render, staticRenderFns } from "./EditCeremonyModal.vue?vue&type=template&id=b169945a"
import script from "./EditCeremonyModal.vue?vue&type=script&setup=true&lang=js"
export * from "./EditCeremonyModal.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports